import Toaster from './Toaster'
import './style.less'

export default {
  install (vue) {
    window.fpuiMessageBlockRemove = Toaster.remove
    vue.fpuiMessageBlock = vue.prototype.$fpuiMessageBlock = Toaster
  }
}
